const profileId = {
	profile: {
		title: "Profil",
		subtitle: "Kelola kata sandi dan akses dukungan",
		tabs: {
			password: "Ganti Kata Sandi",
			support: "Akses Dukungan",
		},
		password: {
			title: "Ganti Kata Sandi",
			old: "Kata Sandi Lama",
			new: "Kata Sandi Baru",
			confirm: "Konfirmasi Kata Sandi Baru",
			submit: "Simpan",
			success: "Kata sandi berhasil diubah",
			errors: {
				required: "Wajib diisi",
				min: "Minimal 8 karakter",
				mismatch: "Konfirmasi kata sandi tidak cocok",
			},
		},
		support: {
			title: "Akses Dukungan",
			description:
				"Izinkan tim dukungan Cazh masuk sementara ke akun Anda untuk membantu penyelesaian kendala.",
			label: "Aktifkan akses dukungan",
			active_until: "Aktif sampai",
			enabled: "Akses dukungan berhasil diaktifkan",
			disabled: "Akses dukungan berhasil dinonaktifkan",
		},
	},
};

export default profileId;
